import about from 'assets/about.png';
import { Card, Col, Image, Row } from 'react-bootstrap';

const AboutCol = () => {
    return (
        <Card className='p-md-5 p-4 rounded-4 border-0 shadow-sm'>
            <Row className='  align-items-xl-center align-items-stretch h-100'>
                <Col lg={6} xs={12} className="">
                <div className="mb-4 mb-md-0 w-100 ">

                    <div className="mb-4">
                        <h4 className='fw-semibold'>Our Vision: Empowering a Forward-Thinking Future</h4>          </div>
                    <p>

                        <strong className='pe-1'>
                            Living Wall

                        </strong>
                        transforms spaces into engaging environments that seamlessly blend the physical and digital worlds. We specialize in consulting for your space transforming projects. Our knowledge is vast as we bring
                        <strong className='px-1'>
                            over 15 years of experience

                        </strong>
                        in digital media and technology. Our team is passionate about generating innovative ideas and translating them into intelligent solutions for our clients.


                    </p>
                    <h6 className='pt-2'>

                        <strong>
                            <i>

                                At Living Wall, we are driven by core values in projects we undertake: innovation, customer focus and integration.
                            </i>
                        </strong>
                    </h6>


                </div>
                </Col>

                <Col lg={6} xs={12} >
                <div className="h-100">
                    <Image src={about} alt="About Image" className="img-fluid h-100" />
                </div>
                </Col>
            </Row>
        </Card>
    );
};

export default AboutCol;
